export const nextFrame = (delay = 50) =>
	new Promise(resolve => setTimeout(resolve, delay));
